import { Sparkles } from "lucide-react";

/**
 * Founding Member badge — awarded permanently to any business that registers
 * before 07/01/2027. Cosmetic only; does not affect ranking.
 */
export default function FoundingMemberBadge({ size = 14, className = "", showLabel = false }) {
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-gradient-to-r from-[#7c3aed] to-[#B31E1E] text-white text-[10px] font-semibold tracking-wide ${className}`}
      title="Founding Member — joined Servrevu before July 1, 2027"
      aria-label="Founding Member"
      data-testid="founding-member-badge"
    >
      <Sparkles size={size - 2} className="fill-white" />
      {showLabel ? <span>Founding Member</span> : <span>Founder</span>}
    </span>
  );
}
